import { VideoTemplateStateContent } from '../../types';

export function getBackgroundColor(state: VideoTemplateStateContent): string {
  return state.backgroundColor;
}
